var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.displayHistory
    ? _c(
        "div",
        { staticClass: "p-2 history-card-log__container br flex ai-center" },
        [
          _c(
            "div",
            { staticClass: "history-card-log__container-history-title" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "typographies-paragraph-small-bold history-card-log__container-history-title__colors-common-text-subtle-default"
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$l10n.__("Historique")) +
                      "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c("CompassIconButton", {
                attrs: { icon: "close", size: "small" },
                on: { click: _vm.closeHistory }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "m-0" },
            _vm._l(_vm.histories, function(history) {
              return _c(
                "li",
                {
                  key: history.objectid + "/" + history.timestamp,
                  staticClass:
                    "history-card-log__item flex-row flex-start ai-center"
                },
                [
                  _vm._m(0, true),
                  _vm._v(" "),
                  _c("LogCard", {
                    staticClass: "ml-2 wp-10",
                    attrs: {
                      linkedid: _vm.linkedid,
                      linkedtype: _vm.linkedtype,
                      "one-log": history
                    }
                  })
                ],
                1
              )
            }),
            0
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "timeline-bullet__container prelative ai-center flex-row"
      },
      [_c("div", { staticClass: "timeline-bullet__item br" })]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }